import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LegislationRecipient } from 'app/legislation/legislation-items/legislation';

@Component({
    selector: 'app-edit-recipient-dialog',
    templateUrl: './add-edit-recipient-dialog.component.html',
    styleUrls: ['./add-edit-recipient-dialog.component.scss'],
})
export class AddEditRecipientDialogComponent implements OnInit {
    title = 'Email Recipient';
    recipient: LegislationRecipient;
    listofrecipients: string[];
    recipientEditorForm: FormGroup;
    
    get name() {
        return this.recipientEditorForm.get('Name') as FormControl;
    }
    get email() {
        return this.recipientEditorForm.get('Email') as FormControl;
    }
    // get group() {
    //     return this.recipientEditorForm.get('Group') as FormControl;
    // }

    constructor(
        private dialogRef: MatDialogRef<AddEditRecipientDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.recipient = data.recipient;
        this.listofrecipients = data.recipientNames;
    }

    ngOnInit(): void {
        const self = this;
        self.recipientEditorForm = self.formBuilder.group({
            // id: [self.recipient.recipientId, ],
            Name: [self.recipient.name, [
                Validators.required, 
                isNameTaken(self.recipient.name, self.listofrecipients)
            ]],
            // FirstName: [self.recipient.firstName],
            // MiddleName: [self.recipient.middleName],
            // Nickname: [self.recipient.nickname],
            // LastName: [self.recipient.lastName],
            // Prefix: [self.recipient.prefix],
            // Suffix: [self.recipient.suffix],
            Email: [self.recipient.email, [Validators.required]],
            // Group: [self.recipient.group, [Validators.required]],
        });

        self.title = self.data.title;
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues): void {
        const self = this;

        self.recipientEditorForm.markAllAsTouched();

        if (this.recipientEditorForm.valid) {
            self.recipient.name = formValues.Name;
            // self.recipient.firstName = formValues.FirstName;
            // self.recipient.middleName = formValues.MiddleName;
            // self.recipient.nickname = formValues.Nickname;
            // self.recipient.lastName = formValues.LastName;
            // self.recipient.prefix = formValues.Prefix;
            // self.recipient.suffix = formValues.Suffix;
            self.recipient.email = formValues.Email;
            // self.recipient.group = formValues.Group;

            self.dialogRef.close(self.recipient);
            self.recipientEditorForm.reset();
        }
    }
}

/* Validation function to see if the inputted recipient name already exists. If so, the field will become invalid.
 * This error will NOT occurr if, while editing an existing recipient name, the user reverts changes to match the
 * original name provide to the form prior to saving.
 */
function isNameTaken(name: string, listofnames: string[]): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        let error = null;
        if (listofnames) {
            const isNameTaken = listofnames.some((value) => value === control.value);
            error = isNameTaken && control.dirty && control.value !== name ? { isNameTaken: true } : null;
        }
        return error;
    };
}
